export function orientedBox(centre, half, axes) {
    return { centre, half, axes };
}
const dot = (a, b) => a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
const cross = (a, b) => [
    a[1] * b[2] - a[2] * b[1],
    a[2] * b[0] - a[0] * b[2],
    a[0] * b[1] - a[1] * b[0],
];
const WORLD = [
    [1, 0, 0],
    [0, 1, 0],
    [0, 0, 1],
];
/** How far a box reaches along `axis` from its middle. */
const reach = (box, axis) => box.half[0] * Math.abs(dot(box.axes[0], axis)) +
    box.half[1] * Math.abs(dot(box.axes[1], axis)) +
    box.half[2] * Math.abs(dot(box.axes[2], axis));
/**
 * Whether an oriented box and an axis-aligned one touch (separating axes:
 * the two boxes' faces and every pair of their edges). Touching counts.
 */
export function boxIntersects(a, box) {
    const b = {
        centre: [
            (box.min[0] + box.max[0]) / 2,
            (box.min[1] + box.max[1]) / 2,
            (box.min[2] + box.max[2]) / 2,
        ],
        half: [
            (box.max[0] - box.min[0]) / 2,
            (box.max[1] - box.min[1]) / 2,
            (box.max[2] - box.min[2]) / 2,
        ],
        axes: WORLD,
    };
    const between = [
        b.centre[0] - a.centre[0],
        b.centre[1] - a.centre[1],
        b.centre[2] - a.centre[2],
    ];
    const axes = [...a.axes, ...b.axes];
    for (const u of a.axes)
        for (const v of b.axes)
            axes.push(cross(u, v));
    for (const axis of axes) {
        // Parallel edges give no axis of their own; the faces cover them.
        if (dot(axis, axis) < 1e-12)
            continue;
        if (Math.abs(dot(between, axis)) > reach(a, axis) + reach(b, axis) + 1e-12)
            return false;
    }
    return true;
}
/** Whether an oriented box and a sphere touch: the box's nearest point is within the radius. */
export function sphereIntersects(a, centre, radius) {
    const d = [centre[0] - a.centre[0], centre[1] - a.centre[1], centre[2] - a.centre[2]];
    let squared = 0;
    for (let i = 0; i < 3; i++) {
        const along = dot(d, a.axes[i]);
        const outside = Math.abs(along) - a.half[i];
        if (outside > 0)
            squared += outside * outside;
    }
    return squared <= radius * radius;
}
//# sourceMappingURL=intersect.js.map